import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import React from "react";
import Loader from "../../../../components/Loader";
import { useSubmitData } from "../../../../hooks/useSubmitData";
import { useBasicWaterQualityParametersInfo } from "./useBasicWaterQualityParametersInfo";
import {
  getButtonIcon,
  getButtonText,
} from "../../wells/wellsManagement/utils";

function BasicWaterQualityParametersInfo({
  selectedWaterQualityParameter,
  setSelectedWaterQualityParameter,
  refetchWaterQualityParameters = () => {},
  isEditMode = false,
}) {
  const {
    isLoading,
    error,
    handleUpdateState,
    handleResetState,
    state,
    refetch,
    isDirty,
    lookups,
  } = useBasicWaterQualityParametersInfo(selectedWaterQualityParameter);

  const { handleSubmit, isFormSubmitting } = useSubmitData(
    selectedWaterQualityParameter,
    setSelectedWaterQualityParameter,
    state,
    "list-aqsci-parameters-with-akas",
    "aqsci_parameter_ndx",
    refetch,
    refetchWaterQualityParameters
  );

  if (error) return "An error has occurred: " + error.message;

  return (
    <>
      {isLoading ||
        (isEditMode && !state?.aqsci_parameter_ndx && (
          <Paper style={{ width: "100%", margin: "8px 0" }}>
            <Loader />
          </Paper>
        ))}
      <Accordion
        defaultExpanded
        style={{
          display:
            isLoading || (isEditMode && !state?.aqsci_parameter_ndx)
              ? "none"
              : "block",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box style={{ width: "100%" }}>
            <Typography variant="h3">Water Quality Parameter Info</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                label="Parameter"
                fullWidth
                required
                error={!state.parameter_name}
                helperText={!state.parameter_name ? "*Required field" : ""}
                onChange={(e) =>
                  handleUpdateState("parameter_name", e.target.value)
                }
                value={state.parameter_name ?? ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                label="Abbrev"
                fullWidth
                required
                error={!state.parameter_abbrev}
                helperText={!state.parameter_abbrev ? "*Required field" : ""}
                onChange={(e) =>
                  handleUpdateState("parameter_abbrev", e.target.value)
                }
                value={state.parameter_abbrev ?? ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl
                variant="outlined"
                fullWidth
                required
                error={!state.aqsci_unit_ndx}
              >
                <InputLabel id="unit-label">Units</InputLabel>
                <Select
                  labelId="unit-label"
                  value={state.aqsci_unit_ndx ?? ""}
                  onChange={(e) =>
                    handleUpdateState("aqsci_unit_ndx", e.target.value)
                  }
                  label="Units *"
                >
                  {lookups.Units?.map((u) => (
                    <MenuItem key={u.aqsci_unit_ndx} value={u.aqsci_unit_ndx}>
                      {u.unit_abbrev}
                    </MenuItem>
                  ))}
                </Select>
                {!state.aqsci_unit_ndx && (
                  <FormHelperText error>*Required field</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                label="Sort"
                fullWidth
                type="number"
                onChange={(e) =>
                  handleUpdateState("display_order", e.target.value)
                }
                value={state.display_order ?? ""}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Notes"
                fullWidth
                multiline
                onChange={(e) => handleUpdateState("notes", e.target.value)}
                value={state.notes ?? ""}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.dataentry_primary || false}
                    onChange={(e) =>
                      handleUpdateState("dataentry_primary", e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Primary"
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.ignore || false}
                    onChange={(e) =>
                      handleUpdateState("ignore", e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Ignore"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <Button size="small" onClick={handleResetState}>
            Reset
          </Button>
          <Button
            size="small"
            color="secondary"
            variant="contained"
            onClick={handleSubmit}
            disabled={
              !isDirty ||
              isFormSubmitting ||
              !state.parameter_name ||
              !state.parameter_abbrev ||
              !state.aqsci_unit_ndx
            }
            startIcon={getButtonIcon(isFormSubmitting)}
            style={{ width: "100px" }}
          >
            {getButtonText(
              isFormSubmitting,
              selectedWaterQualityParameter === 0
            )}
          </Button>
        </AccordionActions>
      </Accordion>
    </>
  );
}

export default BasicWaterQualityParametersInfo;
